import gql from 'graphql-tag';

export const PORTAL_PAYMENTS_QUERY = gql`
    query PortalPayments(
      $operatorId: String!,
      $first: Int,
      $skip: Int,
      $protocol: String,
      $startDate: String,
      $endDate: String,
      $startCaptureDate: String,
      $endCaptureDate: String
    ) {
    portalPayments(
      operatorId: $operatorId,
      first: $first,
      skip: $skip,
      protocol: $protocol
      startDate: $startDate,
      startCaptureDate: $startCaptureDate,
      endCaptureDate: $endCaptureDate,
      endDate: $endDate
    ) {
      pages
      payments {
        id
        order {
          protocol
          portalOrder {
            id
          }
        }
        nsu
        createdAt
        card {
          trunc
          brand
        }
        paymentStatus
        amount
        paymentType
        installments
        installmentsAmount
      }
    }
    }
`;



// WEBPACK FOOTER //
// ./src/components/Pages/Payments/graphql.js